import React from 'react';
import { Play } from 'lucide-react';
interface StartScreenProps {
  onStart: () => void;
}
export const StartScreen: React.FC<StartScreenProps> = ({
  onStart
}) => {
  return <div className="flex flex-col items-center justify-center min-h-screen bg-slate-950 p-6 text-center" data-id="element-35">
      <div className="relative mb-8" data-id="element-36">
        <div className="absolute -inset-4 bg-yellow-500/20 rounded-full blur-3xl animate-pulse-slow" data-id="element-37"></div>
        <h1 className="text-6xl md:text-8xl font-bold text-yellow-400 text-shadow-glow relative z-10 tracking-wide" data-id="element-38">
          Star Seeker
        </h1>
      </div>

      <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-md leading-relaxed" data-id="element-39">
        Find and click the hidden ⭐ among the moving emojis!
      </p>

      <button onClick={onStart} className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-slate-950 bg-yellow-400 rounded-full overflow-hidden transition-transform hover:scale-105 active:scale-95" data-id="element-40">
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-41"></div>
        <span className="relative flex items-center gap-2 text-2xl" data-id="element-42">
          <Play className="w-8 h-8 fill-current" data-id="element-43" />
          Play Now
        </span>
      </button>

      <div className="mt-16 flex gap-4 text-4xl opacity-50" data-id="element-44">
        <span data-id="element-45">🎈</span>
        <span data-id="element-46">🌸</span>
        <span data-id="element-47">🍕</span>
        <span data-id="element-48">🎯</span>
        <span data-id="element-49">🌈</span>
      </div>
    </div>;
};